import type { BasketPatchItem, PlanPeriodNumericId } from "@onestore/api/types"
import type { ProductBoxBundle } from "~/fragments/bundle"

/**
 * Builds the nested `children[0]` basket item for a product-box bundle, or
 * `undefined` when there's nothing to nest. Shared by every place that adds
 * the ax-drawer's main product to the basket (Add to Cart, Buy Now), so the
 * bundle goes in as a child of the main item the same way everywhere —
 * mirroring how the bonus page and ConfigDrawer already add "plan + bundle".
 *
 * @param bundlePlanPeriodId period the drawer priced the bundle for. Without it
 *   the basket falls back to whatever CloudBlue treats as the plan's default
 *   period, which need not be the same one — see getInitialChosenPeriod, which
 *   lands on `periods[0]` when the sale configuration names no period — so the
 *   price shown and the price charged could differ. The bonus page passes it
 *   for the same reason (actions-bundle's getAddToBasketPatchItems).
 */
export function getBundleBasketPatchItem(
  bundle: ProductBoxBundle | undefined,
  bundlePlanPeriodId?: PlanPeriodNumericId
): BasketPatchItem | undefined {
  const bundlePlan = bundle?.flatData.plan?.[0]

  if (!bundlePlan) {
    return undefined
  }

  return {
    plan: bundlePlan.flatData.id,
    planPeriod: bundlePlanPeriodId,
    quantity: 1,
  }
}
